import { useTranslation } from 'react-i18next';

import { BoxProps, Flex, Text } from '@bonusly/design-system';
import { useUser } from '@bonusly/user-queries';

import { ReactComponent as MoveIcon } from '../assets/move-icon.svg';

import '../assets/placeholder.css';

interface PlaceholderProps extends BoxProps {
	suggestedCheckIn?: {
		guestId: string;
		participantName: string;
		score: number;
	};
	showSuggestedCheckinIcon?: boolean;
	onClickSuggestedCheckin?: () => void;
}

export function Placeholder({ suggestedCheckIn, showSuggestedCheckinIcon, onClickSuggestedCheckin, ...props }: PlaceholderProps) {
	const { t } = useTranslation('one_on_ones', { keyPrefix: 'meeting.check_in' });

	// only executed if there's a suggested checkin
	const { data: guest } = useUser(suggestedCheckIn?.guestId);
	const reuse = !!suggestedCheckIn;
	const reuseScore = suggestedCheckIn?.score;
	const reuseParticipantName = guest?.displayFirstName;

	const color = reuse ? 'primary.fg' : 'text.softest';
	const placeholderProps = reuse ? { onClick: onClickSuggestedCheckin, cursor: 'pointer' } : {};

	return (
		<Flex alignItems="center" color={color} gap={2} h="100%" justifyContent="center" w="100%" {...props} {...placeholderProps}>
			{!showSuggestedCheckinIcon && <MoveIcon height={20} width={20} className="move-placeholder-icon" />}
			<Text fontSize="sm">{!reuse ? t('placeholder') : t('reuse_check_in', { participantName: reuseParticipantName, score: reuseScore })}</Text>
		</Flex>
	);
}
